// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pF8f","content":"styles_content__TN1tX"};